<template>
<header class="header">

  <div class="header-brand">
    <h1 class="header-title">
      Visor <span class="header-title-span">GRD</span>
    </h1>

    <NotificationBell :account="!!account" />
  </div>


    <!-- Navegación escritorio -->
    <nav class="navigation">
      <router-link
        v-for="link in links"
        :key="link.path"
        :to="link.path"
        :class="{ 'router-link-active': isNavActive(link) }"
      >
        {{ link.name }}
      </router-link>

      <UserDropdown
        v-if="account"
        class="dropdown-user navigation-account"
      />
    </nav>

    <!-- Botón móvil -->
    <button
      id="collapsible-button"
      class="collapsible-button"
      @click="onClickSelectCollapsible()"
    >
      <font-awesome-icon
        v-if="!isActive"
        icon="chevron-down"
        style="font-size: 2em;"
      />

      <font-awesome-icon
        v-else
        icon="chevron-up"
        style="font-size: 2em;"
      />
    </button>

    <!-- Navegación móvil -->
    <div id="collapsible-content" class="collapsible-content">
      <nav class="navigation-toggle">
        <router-link
          v-for="link in links"
          :key="link.path"
          @click.native="onClickSelectCollapsible()"
          :to="link.path"
        >
          {{ link.name }}
        </router-link>

        <router-link
          v-if="account"
          @click.native="onClickSelectCollapsible()"
          :to="'/cuenta/mi-cuenta'"
        >
          Mi cuenta
        </router-link>

        <router-link
          v-if="account"
          @click.native="onClickSelectCollapsible()"
          :to="'/cuenta/cerrar-sesion'"
        >
          Cerrar sesión
        </router-link>
      </nav>
    </div>

  </header>
</template>

<style lang="scss" scoped>
.header {
  position: relative;
  z-index: 100;

  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;

  min-height: 4.6em;
  padding: 0 5%;

  background: var(--color-navy);
}
.header-brand {
  display: flex;
  align-items: center;
  gap: 0.8em;

  height: 100%;
}

.header-title {
  margin: 0;

  color: var(--color-white);

  font-size: 1.5rem;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;

  &-span {
    color: var(--color-orange);
  }
}
/* =========================================================
   NAVEGACIÓN DE ESCRITORIO
   ========================================================= */

.navigation {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  justify-self: flex-end;
  gap: 8px;
}

.navigation-account {
  position: relative;

  display: flex;
  align-items: center;

  height: 100%;
}

/* =========================================================
   NAVEGACIÓN MÓVIL
   ========================================================= */

.navigation-toggle {
  display: none;
}

.navigation-toggle a {
  padding: 0.85em 0;

  color: rgba(255, 255, 255, 0.9);

  font-weight: bold;
  text-decoration: none;

  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.navigation-toggle a:hover,
.navigation-toggle a.router-link-active {
  color: var(--color-orange);
}

.collapsible-content {
  display: none;
}

.collapsible-button {
  display: none;
}

/* =========================================================
   RESPONSIVE
   ========================================================= */

@media only screen and (max-width: 640px) {
  .header {
    grid-template-columns: auto auto;

    min-height: 4.4em;
  }

  .header-brand {
    gap: 0.5em;
  }

  .header-title {
    font-size: 1.3rem;
  }

  /* Oculta navegación de escritorio */

  .navigation {
    display: none;
  }

  .dropdown-user {
    display: none;
  }

  /* Botón del menú móvil */

  .collapsible-button {
    display: inline;

    justify-self: flex-end;
    align-self: center;

    border: none;
    outline: none;

    background: transparent;
    color: var(--color-white);

    font-size: 1em;
    text-align: end;

    cursor: pointer;
  }

  /* Contenido desplegable móvil */

  .collapsible-content {
    grid-column: 1 / -1;

    display: grid;
    grid-template-columns: 1fr;

    width: 100%;
    max-height: 0;

    overflow: hidden;

    background: transparent;

    text-align: center;

    transition: max-height 0.2s ease-out;
  }

  .navigation-toggle {
    display: grid;
    grid-template-columns: 1fr;
  }
}
</style>
<script>
import UserDropdown from '@/components/UserDropdown.vue'
import NotificationBell from '@/components/NotificationBell.vue'

export default {
  name: 'NavBarCollapsible',

  components: {
    UserDropdown,
    NotificationBell
  },

  props: [
    'links',
    'account'
  ],

  data() {
    return {
      isActive: false
    }
  },

  methods: {
    isNavActive(link) {
      const prefix = link.activeMatch || link.path
      return !!prefix && this.$route.path.indexOf(prefix) === 0
    },

    onClickSelectCollapsible() {
      const content =
        document.getElementById(
          'collapsible-content'
        )

      this.isActive = !this.isActive

      if (content.style.maxHeight) {
        content.style.maxHeight = null
      } else {
        content.style.maxHeight =
          `${content.scrollHeight}px`
      }
    }
  }
}
</script>